"use client"
import React from 'react'
import { useState } from "react"
import { createPortal } from 'react-dom'
import HlsVideo from '@/app/components/HlsVideo'
import WatermarkBadge from '@/app/components/WatermarkBadge'
import { countDown } from '@/app/utils/CountDown'
import type { Gamedetail2Dict } from '@/lib/i18n/dicts/gamedetail2'

const TryGameTime = 180

interface GameDetail2ActionsProps {
    gamehref: string
    gamescreen: string
    gamevideo?: string
    gameid?: number
    /** 按钮与倒计时遮罩文案（gamedetail2Dict.actions 切片，由服务端页面按语言传入） */
    dict: Gamedetail2Dict['actions']
}

/**
 * gamedetail2 深色版试玩动作组件：
 * 按钮放在游戏信息卡片右侧，弹窗逻辑与原 GameDetail_ModelContent 一致
 * （3 分钟试玩倒计时 / mp4 视频 / 横竖版切换 / 926 半屏直播模式 / 玩法视频弹窗）
 * 弹窗通过 createPortal 挂载到 document.body，
 * 避免父级 BlurFade 动画残留的 transform/filter 使 fixed 定位相对卡片而非视口
 */
export default function GameDetail2Actions({ gamehref, gamescreen, gamevideo = "", gameid = 0, dict }: GameDetail2ActionsProps) {
    const [isVideoPoppedUp, setVideoPopUp] = useState(false)
    const [countDownTime, setCountDownTime] = useState(TryGameTime || 0)
    const [currentPhoneHS, setCurrentPhoneHS] = useState(gamescreen)
    const [isGameVideoPopedUp, setGameVideoPopedUp] = useState(false)

    let VarcountDownTime = TryGameTime;

    function changetime(_time: number) {
        VarcountDownTime = VarcountDownTime - 1;
        setCountDownTime(VarcountDownTime);
    }

    function fromatCountDownTime(time: number) {
        let returnvalue = ""
        returnvalue = returnvalue + Math.floor(time / 60) + ":" + (time % 60 > 9 ? time % 60 : "0" + time % 60)
        return returnvalue
    }

    function handleLijiShiwan() {
        if (countDownTime == TryGameTime || countDownTime < 1) {
            setVideoPopUp(true)
            if (!gamehref.endsWith("mp4"))
                countDown(TryGameTime, changetime, countdownEnd);
        }
        else {
            setVideoPopUp(true)
        }
    }

    function handlePlayGameVideo() {
        setGameVideoPopedUp(true)
    }

    function handleCloseGameVideo() {
        setGameVideoPopedUp(false)
    }

    function countdownEnd() {
        var eletrygameCover = document.getElementById('trygameCover')
        if (eletrygameCover != null)
            document.getElementById('trygameCover')!.style.display = "";
        gamehref.endsWith("mp4") ? document.getElementById('popupdivmp4')!.style.display = "none" : document.getElementById('popupdivgame')!.style.display = "none";
    }

    function handleJiXuShiwan() {
        setCountDownTime(0)
        document.getElementById('trygameCover')!.style.display = "none";
        gamehref.endsWith("mp4") ? document.getElementById('popupdivmp4')!.style.display = "" : document.getElementById('popupdivgame')!.style.display = "";
    }

    function handleClose() {
        setCountDownTime(0);
        setVideoPopUp(false)
    }

    function handleChangePhone() {
        setCurrentPhoneHS(currentPhoneHS == '竖版' || currentPhoneHS === '横竖版' ? "横版" : "竖版")
    }

    // 所有弹窗集中到一起，通过 portal 挂到 body，保证相对屏幕居中
    const modals = (
        <>
            {/* 试玩 / 视频弹窗 */}
            {
                isVideoPoppedUp ? (
                    <>
                        {gamehref.endsWith("mp4") ? (
                            <>
                                <div className="fixed inset-0 w-full h-full flex items-center justify-center z-20" id='popupdivmp4'>
                                    <div className="absolute inset-0 w-full h-full bg-black/70 backdrop-blur-sm" onClick={handleClose}></div>
                                    <div className="px-0 relative flex">
                                        <div id='trygame' className="mx-auto p-2 space-y-8 bg-slate-900 ring-1 ring-white/10 rounded-xl max-w-3xl" style={{ display: '' }}>
                                            <div className="relative">
                                                <video className="rounded-lg w-full max-w-md h-[44rem]" controls autoPlay={true} loop={true} controlsList="nodownload" onContextMenu={(e) => e.preventDefault()}>
                                                    <source src={gamehref} type="video/mp4" />
                                                </video>
                                                <WatermarkBadge />
                                            </div>
                                        </div>
                                        <button
                                            className="w-12 h-12 mb-5 rounded-full duration-150 bg-slate-800 hover:bg-slate-700 text-white ring-1 ring-white/15"
                                            onClick={handleClose}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 m-auto">
                                                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </>
                        )
                            :
                            gameid === 926 ? (
                                <>
                                    {/* 926 点球大战为半屏游戏：iframe 框内上半部分为主播直播画面，下半部分显示游戏内容 */}
                                    <div className="fixed inset-0 w-full h-full flex items-center justify-center z-20" id='popupdivgame'>
                                        <div className="absolute inset-0 w-full h-full bg-black/70 backdrop-blur-sm" onClick={handleClose}></div>
                                        <div className="px-0 relative flex">
                                            <div id='trygame' className="mx-auto p-2 space-y-8 bg-slate-900 ring-1 ring-white/10 rounded-xl max-w-4xl" style={{ display: '' }}>
                                                <div className="relative w-96 h-[44rem] rounded-lg overflow-hidden">
                                                    <img
                                                        src="/img/gamedetail/926/live-bg.png"
                                                        alt="直播画面"
                                                        className="absolute top-0 left-0 w-full h-1/2 object-cover"
                                                    />
                                                    <iframe
                                                        id="iframe_gameRef"
                                                        className="absolute bottom-0 left-0 w-full h-1/2 bg-white"
                                                        src={gamehref}>
                                                    </iframe>
                                                </div>
                                            </div>
                                            <div className='flex justify-start flex-col'>
                                                <div className='flex flex-row'></div>
                                                <button
                                                    className="w-12 h-12 align-top content-end right-0 mb-1 rounded-full duration-150 bg-slate-800 hover:bg-slate-700 text-white ring-1 ring-white/15"
                                                    onClick={handleClose}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 m-auto">
                                                        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                                    </svg>
                                                    {countDownTime == 0 ? "" : fromatCountDownTime(countDownTime || 0)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                            :
                            (
                                <>
                                    <div className="fixed inset-0 w-full h-full flex items-center justify-center z-20" id='popupdivgame'>
                                        <div className="absolute inset-0 w-full h-full bg-black/70 backdrop-blur-sm" onClick={handleClose}></div>
                                        <div className="px-0 relative flex">
                                            <div id='trygame' className="mx-auto p-2 space-y-8 bg-slate-900 ring-1 ring-white/10 rounded-xl max-w-4xl" style={{ display: '' }}>
                                                <iframe
                                                    id="iframe_gameRef"
                                                    className={`col-span-2 items-center mx-auto rounded-lg ${currentPhoneHS === '竖版' || currentPhoneHS === '横竖版' ? "w-96 h-[44rem]" : "w-[52rem] h-[28rem]"} `}
                                                    src={gamehref}>
                                                </iframe>
                                            </div>
                                            <div className='flex justify-start flex-col'>
                                                <div className='flex flex-row'></div>
                                                <button
                                                    className="w-12 h-12 align-top content-end right-0 mb-1 rounded-full duration-150 bg-slate-800 hover:bg-slate-700 text-white ring-1 ring-white/15"
                                                    onClick={handleClose}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 m-auto">
                                                        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                                    </svg>
                                                    {countDownTime == 0 ? "" : fromatCountDownTime(countDownTime || 0)}
                                                </button>

                                                {gamescreen === '横竖版' ?
                                                    <button
                                                        className="w-12 h-12 align-top content-end right-0 mb-1 rounded-full duration-150 bg-slate-800 hover:bg-slate-700 text-white ring-1 ring-white/15"
                                                        onClick={handleChangePhone}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`w-5 h-5 m-auto ${currentPhoneHS === '竖版' || currentPhoneHS === '横竖版' ? "rotate-90" : ""}`}>
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
                                                        </svg>
                                                    </button>
                                                    : ""}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                    </>
                ) : ""
            }

            {/* 试玩倒计时结束遮罩 */}
            {
                isVideoPoppedUp ? <div id='trygameCover' className="fixed inset-0 w-full h-full flex items-center justify-center z-30 bg-black/40" style={{ display: 'none' }}>
                    <div className="absolute inset-0 w-full h-full bg-black/60 backdrop-blur-sm" onClick={handleClose}></div>
                    <div className='mx-auto text-center text-white'>
                        <div className="relative flex min-h-screen flex-col justify-center overflow-hidden py-6 sm:py-12">
                            <div className="mx-auto max-w-4xl rounded-3xl bg-slate-900 ring-1 ring-indigo-400/30 p-20 text-center shadow-2xl shadow-indigo-600/20">
                                <h2 className="text-4xl font-bold leading-tight text-white">{dict.contactTitle}</h2>
                                <p className="mt-5 text-2xl leading-8 text-indigo-300">188 0038 2271</p>
                                <div className="mt-6 flex items-center justify-center gap-4">
                                    <button className="flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-indigo-500 to-fuchsia-500 px-5 py-3 text-lg font-medium text-white">
                                        <span>{dict.backToLibrary}</span>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M6.00156 13.4016L4.60156 12.0016L8.60156 8.00156L4.60156 4.00156L6.00156 2.60156L11.4016 8.00156L6.00156 13.4016Z" fill="white" /></svg></span>
                                    </button>
                                    <button className="flex items-center justify-center gap-2 rounded-full border border-white/50 px-5 py-3 text-lg font-medium text-white hover:bg-white/5"
                                        onClick={handleJiXuShiwan}
                                    >
                                        <span>{dict.keepPlaying}</span>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M6.00156 13.4016L4.60156 12.0016L8.60156 8.00156L4.60156 4.00156L6.00156 2.60156L11.4016 8.00156L6.00156 13.4016Z" fill="white" />
                                            </svg></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    : ""}

            {/* 玩法视频弹窗 */}
            {
                isGameVideoPopedUp ?
                    (
                        <>
                            <div className="fixed inset-0 w-full h-full flex items-center justify-center z-20" id='popupgamevideo'>
                                <div className="absolute inset-0 w-full h-full bg-black/70 backdrop-blur-sm" onClick={handleCloseGameVideo}></div>
                                <div className="px-0 relative flex">
                                    <div id='playgamevideo' className="mx-auto p-2 space-y-8 bg-slate-900 ring-1 ring-white/10 rounded-xl max-w-5xl" style={{ display: '' }}>
                                        <div className="relative">
                                            <HlsVideo className="rounded-lg w-full max-w-5xl h-full" controls autoPlay={true} loop={true} src={gamevideo} />
                                            <WatermarkBadge />
                                        </div>
                                    </div>
                                    <button
                                        className="w-12 h-12 mb-5 rounded-full duration-150 bg-slate-800 hover:bg-slate-700 text-white ring-1 ring-white/15"
                                        onClick={handleCloseGameVideo}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 m-auto">
                                            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </>
                    ) :
                    (
                        <></>
                    )
            }
        </>
    )

    return (
        <>
            {/* 动作按钮（置于游戏信息卡片右侧） */}
            <div className="flex flex-col gap-3 w-full lg:w-56 shrink-0">
                <button
                    onClick={handleLijiShiwan}
                    className="group inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-indigo-500 to-fuchsia-500 px-6 py-3.5 text-sm font-bold text-white shadow-lg shadow-indigo-600/30 transition-all duration-300 hover:scale-[1.04] hover:shadow-indigo-500/40"
                >
                    {gamehref.endsWith("mp4") ? (
                        <>
                            <span>{dict.playVideo}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 transition-transform duration-300 group-hover:scale-110">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
                            </svg>
                        </>
                    ) : (
                        <>
                            <span>{dict.playNow}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="transition-transform duration-300 group-hover:translate-x-0.5">
                                <path fill="currentcolor" d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
                            </svg>
                        </>
                    )}
                </button>

                {gamevideo == "" ? "" : (
                    <button
                        onClick={handlePlayGameVideo}
                        className="inline-flex items-center justify-center gap-2 rounded-full ring-1 ring-white/20 px-6 py-3.5 text-sm font-medium text-slate-200 transition-all duration-300 hover:bg-white/5 hover:ring-white/40"
                    >
                        <span>{dict.playVideo}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
                        </svg>
                    </button>
                )}
            </div>

            {/* 弹窗挂到 body，避免父级 BlurFade 的 transform 影响 fixed 居中定位 */}
            {typeof document !== 'undefined' ? createPortal(modals, document.body) : null}
        </>
    )
}
